export const StakingRoutes = {
	Staking: {
		path: 'staking',
		initialRouteName: '',
		screens: {
			Overview: {
				path: 'overview',
			},
			Enrollments: {
				path: 'enrollments',
			},
			EnrollmentDetails: {
				path: 'enrollment-details',
			},
		},
	},
};

export type StakingParams = keyof typeof StakingRoutes.Staking.screens;

export type StakingParamsRecord = Record<StakingParams, undefined>;
